<template>
  <div class="state control">
    <div class="title">
      <input type="text" class="answerTitle" :placeholder="$t('common.title')" v-model="tmp.title"/>

      <div class="windowButtons">
        <button class="delete" :aria-label="$t('common.actions.delete')" v-on:click="remove()"></button>
      </div>
    </div>
  </div>
</template>

<script>
    import BaseComponent from '../BaseComponent'
    export default {
        name: 'OutState',
        extends: BaseComponent,
        // mixins:[ BaseNodeComponent ],
        props: ['answerTitle', 'remove'],
        methods:{

        },
        data() {
            return {
                tmp: {
                    title: ''
                }
            }
        },
        mounted() {
            this.tmp.title = '' + (this._props.answerTitle || '')
        }
    }
</script>

<style scoped>
  .title .answerTitle {
    overflow-x: hidden;
    padding-right: 4px;
    display: inline-block;
    font-weight: bold;
    border: none;
    background-color: transparent;
    width: 86%;
    max-width: 600px;
    font-size: large;
  }

  .title .delete {
    background-color: indianred;
    margin-left: 16px;
  }
  .title {
    font-size: medium;
    margin-bottom: 8px;
  }
  .windowButtons {
    float: right;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// OutState.vue?52bd0b82